import { useNavigate } from 'react-router-dom';
import { KWELLO_ICON, KwelloSvgIcon } from '../../components/icon/KwelloSvgIcon';
import { APP_ROOT } from 'routes/routes.const';

const Header = () => {
  const navigate = useNavigate();
  const redirectToLogin = () => {
    navigate(APP_ROOT);
  };

  return (
    <div className="header-container">
      <span className="header-logo">
        <KwelloSvgIcon icon={KWELLO_ICON.KWELLO_LOGO} />
      </span>
      <span onClick={redirectToLogin} className={`login base-loud-desktop-blue-700`}>
        <KwelloSvgIcon icon={KWELLO_ICON.LOGIN_ICON} />
        Login
      </span>
    </div>
  );
};

export default Header;
